export default ({ Vue, app }) => {
  Vue.filter('phone', (phone) => {
    if (phone && phone.length === 10) return `(${phone.substring(0, 3)})-${phone.substring(3, 6)}-${phone.substring(6)}`;
    return phone;
    //return app.i18n.t('system.na');
  });
};
